import React from 'react'
import type { MenuItemProps as MuiMenuItemProps } from '@material-ui/core/MenuItem'
import MuiMenuItem from '@material-ui/core/MenuItem'
import type { SvgIconProps } from '@material-ui/core/SvgIcon'
import type { Theme } from '@material-ui/core/styles'
import { makeStyles } from '@material-ui/core'
import type { StyleClasses } from '../../styles'

export interface MenuItemProps extends MuiMenuItemProps {
  classes?: MuiMenuItemProps['classes'] & StyleClasses<typeof useStyles>
  icon?: React.ComponentType<SvgIconProps>
  image?: string
  iconAfter?: boolean
  onClick?: (event?: React.MouseEvent<HTMLElement>) => void
  disabled?: boolean
  children?: React.ReactNode
  iconOnly?: boolean
}

const useStyles = makeStyles<Theme, MenuItemProps>((theme: Theme) => ({
  root: {
    '& img': {
      fontSize: '1.5em',
      width: '1em',
      height: '1em',
      marginRight: '1rem'
    }
  },
  selected: {},
  gutters: {},
  icon: {
    color: 'rgba(0, 0, 0, 0.54)',
    marginRight: theme.typography.pxToRem(16)
  },
  iconAfter: {
    color: 'rgba(0, 0, 0, 0.54)',
    marginLeft: theme.typography.pxToRem(16)
  }
}))

const MenuItem = React.forwardRef<HTMLUListElement, MenuItemProps>(function MenuItem(
  { icon, image, children, iconAfter, button: _button, ...props },
  ref
) {
  const classes = useStyles(props)
  const Icon = icon

  return (
    <MuiMenuItem
      {...props}
      ref={ref as any}
      classes={{ root: classes.root, gutters: classes.gutters, selected: classes.selected }}
    >
      {icon && !iconAfter && <Icon className={classes.icon} />}
      {image && !icon && <img src={image} />}
      {children}
      {icon && iconAfter && <Icon className={classes.iconAfter} />}
    </MuiMenuItem>
  )
})

MenuItem.defaultProps = {
  disabled: false,
  iconAfter: false
}

export default MenuItem
